export default __webpack_public_path__ + "static/media/GTWalsheimPro-Bold.2dbf49e9.ttf";